export default {
  // apiServerUrl: 'https://szwalnia.the-dev.org/',
  apiServerUrl: 'https://szwalnia-smpro.the-dev.org/',
  useConfig: 'dev',
  isSMPRO: true,
  additionalConfig: {
    'prod': {
      hplUrl: 'https://headwear.thecamels.pl/'
    },
    'dev': {
      hplUrl: 'https://headwear2.the-dev.org/'
    }
  }
};
